// Mock data para la landing page de GONSO

export const products = [
  {
    id: 1,
    name: "Tomate",
    variety: "Variedad Pony",
    presentation: "Cesta de 30 lbs",
    availability: "Todo el año (sujeto a disponibilidad estacional  y contratos vigentes)",
    image: "https://customer-assets.emergentagent.com/job_gonso-produccion/artifacts/kb92yadd_image.png"
  },
  {
    id: 2,
    name: "Chile",
    variety: "Variedades Nataly e Iguazú",
    presentation: "Cesta de 15 lbs",
    availability: "Todo el año (sujeto a disponibilidad estacional  y contratos vigentes)",
    image: "https://customer-assets.emergentagent.com/job_gonso-produccion/artifacts/olhse5ea_image.png"
  },
  {
    id: 3,
    name: "Cebolla",
    variety: "Variedades Andromeda, Bella Dura, 7030 y Amarilla",
    presentation: "Sacos de 50 lbs",
    availability: "Disponibilidad variable según época del año",
    image: "https://customer-assets.emergentagent.com/job_gonso-produccion/artifacts/gnoduh38_image.png"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_gonso-produccion/artifacts/7fz0os7z_image.png",
    alt: "Campo de cultivo"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_gonso-produccion/artifacts/9favuj53_image.png",
    alt: "Producción agrícola"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_gonso-produccion/artifacts/vqqc1xyw_image.png",
    alt: "Cultivos frescos"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_gonso-produccion/artifacts/a76pa7y0_image.png",
    alt: "Instalaciones"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_gonso-produccion/artifacts/ifyr8z62_image.png",
    alt: "Productos frescos"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_gonso-produccion/artifacts/vficcy21_image.png",
    alt: "Hortalizas de calidad"
  }
];

export const companyInfo = {
  name: "GONSO",
  tagline: "Produciendo para Honduras",
  location: "El Pescadero – Km 9, carretera Danlí–El Paraíso. Contiguo a Ciudad Nueva Pescadero.",
  phone: "+504 88606154",
  email: "Gonso0500@gmail.com",
  whatsapp: "+50488606154",
  deliveryZones: "Entregas a nivel nacional"
};

// Mock function para simular envío de formulario
export const submitQuoteRequest = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Cotización enviada:", formData);
      resolve({ success: true, message: "Cotización enviada exitosamente" });
    }, 1000);
  });
};
